import type { ReactNode } from 'react';

import clsx from 'clsx';

import type { RadioProps } from '@/components/base/Radio';
// Components
import Radio from '@/components/base/Radio';

const RadioLabelVariants = {
    button: {
        defaultStyle:
            'cursor-pointer gap-2 rounded-md h-12 px-5 flex items-center justify-between text-sm',
        checkedStyle: 'border border-icoBlue ring-1 ring-icoBlue',
        unCheckedStyle: 'border border-icoGray-300'
    },
    buttonSimple: {
        defaultStyle:
            'cursor-pointer gap-2 rounded-md h-12 px-5 flex items-center justify-between text-sm',
        checkedStyle: 'border border-icoGray-300',
        unCheckedStyle: 'border border-icoGray-300'
    }
} as const;

type RadioLabelProps = RadioProps & {
    variant?: keyof typeof RadioLabelVariants;
    classNameLabel?: string;
    children: ReactNode;
};

function RadioLabel({ classNameLabel, variant, checked, children, ...restProps }: RadioLabelProps) {
    return (
        <label
            className={clsx(
                classNameLabel,
                RadioLabelVariants[variant]?.defaultStyle,
                checked
                    ? RadioLabelVariants[variant]?.checkedStyle
                    : RadioLabelVariants[variant]?.unCheckedStyle
            )}>
            {children}
            <Radio checked={checked} {...restProps} />
        </label>
    );
}

export default RadioLabel;
